const doc = [["event-2026-08-28_001_ticket-sale-announcement", "2025-10-13", "2025-04-02"]];
module.exports = doc.length <= 1 ? doc[0] : doc;